import { useColorMode } from "../common/components/chakra/color-mode.tsx";
import type { ImgHTMLAttributes } from "react";

type LogoProps = ImgHTMLAttributes<HTMLImageElement>;

const Logo = (props: LogoProps) => {
  const colorMode = useColorMode();
  return (
    <>
      {colorMode.colorMode === "light" ? (
        <img src={"/LogoBlue.png"} alt={"Light Group VIP Logo"} {...props} />
      ) : (
        <img src={"/LogoWhite.png"} alt={"Light Group VIP Logo"} {...props} />
      )}
    </>
  );
};

export default Logo;
